import React from 'react';
import { WindowSidebarLeftBlank18 } from 'shared/assets/icons';
import { Favorites } from 'shared/components/connected/favorites';
import { NavigationTagsList } from 'shared/components/connected/navigation-tags-list';
import { Colors, IconButton, Sizes } from 'shared/components/ui/icon-button';
import { sideNavigationHoverClass } from 'shared/constants';
import { useOpenSearchDialog } from 'shared/contexts/search';
import { useElectron } from 'shared/hooks/use-is-mac';
import { Paths } from 'shared/routes';
import { mainNavigation } from 'shared/routes/navigation';

import { NavigationSection } from './navigation-section';
import { ResizableContainer } from './resizable-container';
import * as Styled from './side-navigation.style';
import { UserButton } from './user-button';

export type SideNavigationProps = {
  open: boolean;
  mobileOpen: boolean;
  toggleOpen: () => void;
  toggleMobileOpen: () => void;
  onNavigationItem: () => void;
  activePath?: Paths;
};

export const SideNavigation: React.FC<SideNavigationProps> = ({
  open,
  mobileOpen,
  toggleOpen,
  toggleMobileOpen,
  onNavigationItem,
  activePath,
}) => {
  const { isMac } = useElectron();
  const openSearchDialog = useOpenSearchDialog();

  return (
    <>
      <Styled.SmallScreenBackdrop
        onClick={toggleMobileOpen}
        $open={mobileOpen}
      />

      <ResizableContainer open={open} smallScreenOpen={mobileOpen}>
        <Styled.ContentContainer $open={open} $smallScreenOpen={mobileOpen}>
          {isMac && (
            <Styled.AppNavBar>
              <IconButton
                className={sideNavigationHoverClass}
                icon={WindowSidebarLeftBlank18}
                onClick={toggleOpen}
                size={Sizes.Medium}
                color={Colors.Default}
                preventDrag
              />
            </Styled.AppNavBar>
          )}
          <Styled.Header $isMac={isMac}>
            <UserButton
              onCloseSideNavigation={isMac ? undefined : toggleOpen}
              onCloseMobileSideNavigation={toggleMobileOpen}
              onSearch={openSearchDialog}
            />
          </Styled.Header>

          <Styled.List>
            {mainNavigation.map((navigationItem, index) => (
              <Styled.ListItem key={navigationItem.id}>
                <NavigationSection
                  translationLabel={navigationItem.translationLabel}
                  subItems={navigationItem.subItems}
                  initialOpen
                  onNavigationItem={onNavigationItem}
                  activePath={activePath}
                  isFirst={index === 0}
                />
              </Styled.ListItem>
            ))}

            <Favorites />

            <NavigationTagsList />
          </Styled.List>
        </Styled.ContentContainer>
      </ResizableContainer>
    </>
  );
};
